import React from "react";
import { highestQualification } from "../selectData";
import TextEditor from "../components/TextEditor";

export default ({ onChange, editorChange, handleGetDate }) => (
  <div>
    <div className="field">
      <label className="">Job title</label>
      <div className="control">
        <input className="input" type="text" onChange={onChange("title")} />
      </div>
    </div>

    <div className="mb2">
      <label className="label">Minimum qualification</label>
      <div className="control">
        <div className="select">
          <select required onChange={onChange("minimumQualification")}>
            <option>Select</option>
            {highestQualification.map((x, i) => (
              <option key={i} value={x}>
                {x}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>

    <div className="field">
      <label className="">Job Description</label>
      <TextEditor onChange={editorChange} field="description" />
    </div>

    <div className="field">
      <label className="">Requirements</label>
      <TextEditor onChange={editorChange} field="requirements" />
    </div>

    <div className="field">
      <label className="">Professional Certification</label>
      <TextEditor onChange={editorChange} field="certification" />
    </div>

    <div className="field">
      <label className="">Educational Qualification</label>
      <TextEditor onChange={editorChange} field="education" />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/PostJobForm.js